import { Component } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { DesignService } from 'src/app/state';

@Component({
  selector: 'em-equipment-details',
  templateUrl: './equipment-details.component.html',
  standalone: false,
})
export class EquipmentDetailsComponent {
  public designLoading$ = this.designService.loading$;
  public equipmentDetails$ = this.equipmentFacade.equipmentDetails$;
  public equipmentLoading$ = this.equipmentFacade.loading$;
  public error$ = this.equipmentFacade.error$;

  public loading$ = combineLatest([this.designLoading$, this.equipmentLoading$]).pipe(
    map(([designLoading, equipmentLoading]) => designLoading || equipmentLoading)
  );

  public readonly errorMessage$ = this.error$.pipe(
    map((err) => {
      if (typeof err === 'string') return err;
      if (err instanceof Error) return err.message;

      return undefined;
    })
  );

  public constructor(
    private readonly designService: DesignService,
    private readonly equipmentFacade: EquipmentFacadeService
  ) {}
}
